var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelect(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 53,
    viewBox: "0 0 32 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_872_2772)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4.81836,
    y: 15,
    width: 22.4478,
    height: 30,
    fill: "url(#pattern0)"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 27.2656,
    y: 30,
    width: 22.4478,
    height: 30,
    transform: "rotate(-180 27.2656 30)",
    fill: "url(#pattern1)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_872_2772",
    x: 0.818359,
    y: 0,
    width: 30.4473,
    height: 53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_872_2772"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_872_2772",
    result: "shape"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_872_2772",
    transform: "translate(0 0.125871) scale(0.01 0.00748259)"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_872_2772",
    transform: "translate(0 0.125871) scale(0.01 0.00748259)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_872_2772",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAABmJLR0QA/wD/AP+gvaeTAAAEoklEQVR4nO3bf2jUdRzH8efnu62UMKgbNJMoUOwPiX7sZiEIQVAQFJKwocNMI7MJQvYDKaGDSCgIw5reDZMgCkroD6GIIggi0bazKNe8783cai63vJtp6n75/fTHujxrrbXv5/P5fq+9H3/ebq/Xh73vc5+7++5ACCGEEEIIIYQQQgghhBBCCCGEEEIIIYQQQsxSykjKLU9cw4h+GbgXuNpIZuU4A3zC6Jxn6XntdNgwAwNJeSw++SVwV/isinYAv245pIIwIV7oZSwaWIoMA2AZi08mw4aEH4gXXBs64/9C6dB/i/ADqRk/yMTz6Gx3hiu8Q2FDwg+k880iqKdC51Q6pbfw3e6hsDFVJtZCoeMwieRNwG1G8iqN4l1ymW0mosLvkJLzc1tAf2Msr1JojnA2eMxUnLmB9O24QBWNzK7z5DfwGulvO28q0NxAALoyeRTGHi2xp9hIfleXyUgzZ0i5QkcniWQtsNR4dpwodpJLv2I61uwOKZkXbAEOWMmOh6+oLjxjI9jMZ1mTWdhyA1XBYaDWWkc0hlDj9eT2HLcRbmeHABzb9RPotUCoz3ZiRqP0OlvDABtnSLlCNk+iYQ6w3GqPK4rt5DK7bVbY2yEl/nXbgE+t99im+Zxc4QXbNfYHQipgbHwN0G+/y5oBvOpm2HfRdpGDgQDH9wwQqNXAuJM+sy6Cbib3hpMHlN0zpFyxo5dE/Tioe5x1mqDUc/jpt53VuSr6s2/x4x+AWuG4d4b0h/iZBwDtqtHNU9Ylmiu99aCsvWw0RvEjXvVaHA4D3A+EiWsGqgkYcd49fSOgV3K0teC62N0ZUq7Q3k+iYQi4P5L+f6PYTC6zP4rqaAYCUOhoJ5FcCNwa2Rompd7DT2+Nqt39U1a5Gq8F+D7SNVxG+wTVG6JcgetXWX+3aNMSvOAQ6KuiXYg6R+DdSXdrZ5SriHaHAHS3dqLNXQINYVPUw4Aoz5ByxewREskFQH0k/YoMfvqlSLr/IvodUjI6vBnIRtD8LefmPhlB76TiM5Cet4apqloJFN2V6tMEwUP07bjgrnNq8RkIQFdrL4F+BDfvjjWaR+luO+aga9ricYaUK2Z9Esl5wDKrPUq9ip/eabVjBuK1Q0qur9sKfGGx4SDVp563mD9j0b8P+SdLWuoYC74G6gwnDwJ34KdPGM41Ip47BKBz10mUtxoweZUuIPDWxHUYEMczpFyhvYdEUgF3mwnUKfLpvWay7IjvDinx614E9bGBpM/wi7F48zeV+A+EVEDNaDPQGyKkj6BmlYt/UgirAgbCxJeCdNAEjM7gt8cgWEX367+YXpYN8T5DyhWzJ0gkzwH3/affU+pp/Mz7dhZlXnxf9k5OcfPGfWhWTuvemv3k0ytwfF08jMp4yrpEw+g64Og07tvNxeBhKmgYUHkDgdzes3hBI4qpvrU0TBA08UPbr87WZUjlnCHlTmUHSTQMAg9O+nOlN5Jv+8jtosyozIHAxDd/a+tvBHX7Zbdr9uJnUhGtKrTqqBcQyvz5G+j/uQdo/uOWd1gwfzv5KBclhBBCCCGEEEIIIYQQQgghhBBCCCGEEEIIIcSM/A7MvzUjhi1boQAAAABJRU5ErkJggg=="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelect);
export default __webpack_public_path__ + "static/media/select.f326ad3754319185cd16168043885d36.svg";
export { ForwardRef as ReactComponent };